import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Layout from '@/apps/layout/Layout.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: Layout,
    name: 'Layout',
    redirect: {
      name: 'AuthPage',
    },
    children: [
      {
        path: '/auth',
        component: () => import('@/pages/AuthPage'),
        name: 'AuthPage',
      },
      {
        path: '/password-recovery',
        component: () => import('@/pages/PasswordRecoveryPage'),
        name: 'PasswordRecoveryPage',
      },
      {
        path: '/new-password',
        component: () => import('@/pages/NewPasswordPage'),
        name: 'NewPasswordPage',
      },
      {
        path: '/clinic-choice',
        component: () => import('@/pages/ClinicChoicePage'),
        name: 'ClinicChoicePage',
      },
      {
        path: '/patient',
        component: () => import('@/pages/PatientListingPage'),
        name: 'PatientListingPage',
        children: [
          {
            path: '/patient/create',
            component: () => import('@/pages/PatientCreationPage'),
            name: 'PatientCreationPage',
          },
          {
            path: '/patient/report-create/:patientId',
            component: () => import('@/pages/ReportCreationPage'),
            name: 'ReportCreationPage',
          },
          {
            path: '/patient/:patientId',
            component: () => import('@/pages/PatientPage'),
            name: 'PatientPage',
            children: [
              {
                path: '/patient/:patientId/plaque-index-report/:reportId',
                component: () => import('@/pages/PlaqueReportPage'),
                name: 'PlaqueIndexReportPage',
              },
              {
                path: '/patient/:patientId/old-report/:reportId',
                component: () => import('@/pages/OldReportPage'),
                name: 'OldReportPage',
              },
              {
                path: '/patient/:patientId/periodontal-report/:reportId',
                component: () => import('@/pages/PeriodontalPage'),
                name: 'PeriodontalPage',
              },
              {
                path: '/patient/:patientId/brush-report/:reportId',
                component: () => import('@/pages/BrushMapPage'),
                name: 'BrushMapPage',
              },
              {
                path: '/patient/:patientId/screening/:reportId',
                component: () => import('@/pages/ScreeningPage'),
                name: 'ScreeningReportPage',
              },
              {
                path: '/patient/:patientId/risk-report/:reportId',
                component: () => import('@/pages/RiskMapPage'),
                name: 'RiskMapPage',
              },
              {
                path: '/patient/:patientId/edit',
                component: () => import('@/pages/PatientEditionPage'),
                name: 'PatientEditionPage',
              },
            ],
          },
        ],
      },
      {
        path: '/statistic-table',
        component: () => import('@/pages/StatisticTablePage'),
        name: 'StatisticTablePage',
      },
      {
        path: '/statistic-table/:organizationId',
        component: () => import('@/pages/StatisticTablePage'),
        name: 'StatisticTableUserPage',
      },
      {
        path: '/statistic',
        component: () => import('@/pages/StatisticPage'),
        name: 'StatisticPage',
      },
      {
        path: '/admin/users',
        component: () => import('@/pages/admin/OrganizationListingPage'),
        name: 'UserListingPage',
        redirect: {
          path: '/admin/users/all',
        },
        children: [
          {
            path: '/admin/users/:organizationId',
            component: () => import('@/pages/admin/UserPage'),
            name: 'UserPage',
            children: [
              {
                path: '/admin/users/show/:userId/:organizationId',
                component: () => import('@/pages/admin/AdminStatisticPage'),
                name: 'UsersShowPage',
              },
            ],
          },
          {
            path: '/admin/users/:userId/edit',
            component: () => import('@/pages/admin/UserEditionPage'),
            name: 'UserEditionPage',
          },
          {
            path: '/admin/users/create',
            component: () => import('@/pages/admin/UserCreationPage'),
            name: 'UserCreationPage',
          },
          {
            path: '/admin/settings',
            component: () => import('@/pages/admin/SettingsPage'),
            name: 'SettingsPage',
          },
        ],
      },
      {
        path: '/admin/organizations',
        component: () => import('@/pages/admin/OrganizationListingPage'),
        name: 'AllOrganizationsPage',
        children: [
          {
            path: '/admin/organizations/:organizationId/edit',
            component: () => import('@/pages/admin/OrganizationEditionPage'),
            name: 'OrganizationEditionPage',
          },
          {
            path: '/admin/organizations/create',
            component: () => import('@/pages/admin/OrganizationCreationPage'),
            name: 'OrganizationCreationPage',
          },
          {
            path: '/admin/organizations/:organizationId',
            component: () => import('@/pages/admin/UserPage'),
            name: 'OrganizationPage',
            children: [
              {
                path: '/admin/organizations/:organizationId',
                component: () => import('@/pages/admin/AdminStatisticPage'),
                name: 'OrganizationStatisticPage',
              },
              {
                path: '/admin/organizations/show/:organizationId/:userId',
                component: () => import('@/pages/admin/AdminStatisticPage'),
                name: 'OrganizationsShowPage',
              },
            ],
          },
        ],
      },
      {
        path: '/admin/reports',
        component: () => import('@/pages/admin/ReportsPage'),
        name: 'ReportsPage',
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL ?? '/'),
  routes,
})

export default router
